import React from 'react';

import { useTranslation, Trans } from "react-i18next";

import Fade from 'react-reveal/Fade'

function CustomizableDimensions () {

    const { t } = useTranslation();

    const data = [
        { t1: "4 mm", t2: "150x150 mm", t3: "2200x6000 mm", t4: "4 kg" },
        { t1: "4 mm", t2: "200x200 mm", t3: "2200x6000 mm", t4: "4.5 kg" },
        { t1: "6 mm", t2: "150x150 mm", t3: "2200x6000 mm", t4: "12.4 kg" },
        { t1: "6 mm", t2: "200x200 mm", t3: "2200x6000 mm", t4: "8.5 kg" },
        { t1: "8 mm", t2: "150x150 mm", t3: "2200x6000 mm", t4: "18.5 kg" },
        { t1: "8 mm", t2: "200x200 mm", t3: "2200x6000 mm", t4: "13 kg" },
        { t1: "10 mm", t2: "150x150 mm", t3: "2200x6000 mm", t4: "34 kg" },
        { t1: "10 mm", t2: "200x200 mm", t3: "2200x6000 mm", t4: "24 kg" }
    ];
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto relative flex flex-col items-center">
                <p className="open-sans text-[#F26522] text-[28px] xl:text-[45px]">{t('CompositeMesh.8')}</p>
                <p className="text-[#F26522] open-sans text-[18px] xl:text-[20px] mt-[10px] text-center md:max-w-[480px]">{t('CompositeMesh.9')}</p>
                <div className='w-full mt-[35px] md:mt-[65px]'>
                    <table className="min-w-full border-separate border-spacing-y-[4px] relative overflow-hidden">
                        <thead className="bg-[#F26522] open-sans text-[#1D1D1D] text-[12px] xl:text-[20px]">
                            <tr>
                                <th className="p-[8px] md:p-[15px] text-left font-[600]">
                                    {t("CompositeMesh.10")}
                                </th>
                                <th className="p-[8px] md:p-[15px] text-left font-[600] md:font-[300]">
                                    {t("CompositeMesh.11")}
                                </th>
                                <th className="p-[8px] md:p-[15px] text-left font-[600] md:font-[300]">
                                    {t("CompositeMesh.12")}
                                </th>
                                <th className="p-[8px] md:p-[15px] text-left font-[600] md:font-[300]">
                                    {t("CompositeMesh.13")}
                                </th>
                            </tr>
                        </thead>
                        <tbody className="">
                            {data.map((item, index) => (
                                <Fade bottom delay={index * 150} key={item.type}>
                                    <tr>
                                    <td className="p-[8px] md:p-[15px] text-[12px] md:text-[16px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                                        {t(item.t1)}
                                    </td>
                                    <td className="p-[8px] md:p-[15px] text-[12px] md:text-[16px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                                        {t(item.t2)}
                                    </td>
                                    <td className="p-[8px] md:p-[15px] text-[12px] md:text-[16px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                                        {t(item.t3)}
                                    </td>
                                    <td className="p-[8px] md:p-[15px] text-[12px] md:text-[16px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                                        {t(item.t4)}
                                    </td>
                                    </tr>
                                </Fade>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default CustomizableDimensions;